import React, { useState, useEffect } from "react";
import { scrollToAnchor, handleAccount } from "./Service";
import arrowDown from "./img/arrow-down.svg";

export const Banner = ({ content, lang }) => {
    const [selectBanner, setSelectBanner] = useState(0);

    const [mcClass, setMcClass] = useState({
        img: "",
        bar: "",
    });
    const [mercedesClass, setMercedesClass] = useState({
        img: "",
        bar: "",
    });
    const [audiClass, setAudiClass] = useState({
        img: "",
        bar: "",
    });

    const bannerClasses = [mcClass, mercedesClass, audiClass];
    const setBannerClasses = [setMcClass, setMercedesClass, setAudiClass];

    const changeClass = (index = 0) => {
        for (let i = 0; i < bannerClasses.length; i++) {
            i == index
                ? setBannerClasses[i]({
                      img: "banner-show",
                      bar: "bar-progressing",
                  })
                : setBannerClasses[i]({
                      img: "hide",
                      bar: "bar-normal",
                  });
        }

        return;
    };

    const langArr = ["en", "zh", "ar", "id", "es", "vi"];
    const langIndex = langArr.indexOf(lang);

    const [selectLangOpen, setSelectLangOpen] = useState(false);

    const changeLang = (index) => {
        let urlArr = window.location.href.split("/");

        // Change different sub-domain to update language based on current url.
        const langUrlIndex = urlArr[2].includes("lprsc") ? 6 : 3;

        if (langArr[index] != urlArr[langUrlIndex]) {
            urlArr.splice(langUrlIndex, 1, langArr[index]);

            window.location.href = urlArr.join("/");
        }

        setSelectLangOpen(false);
    };

    useEffect(() => {
        changeClass(selectBanner);

        let timer = setTimeout(() => {
            let nextBannerIndex =
                selectBanner + 1 == bannerClasses.length ? 0 : selectBanner + 1;
            setSelectBanner(nextBannerIndex);
        }, 5000);

        return () => clearTimeout(timer);
    }, [selectBanner]);

    return (
        <div className="banner-wrapper">
            <div className="banner-imgs">
                <div className="banner-nav">
                    <a href={`/${lang}`} target="__blank">
                        <img src={content.logo} className="acy-logo"/>
                    </a>
                    <div className="nav-right">
                        <div className="lang-selector">
                            <div
                                className="selected-lang"
                                onClick={() =>
                                    setSelectLangOpen(!selectLangOpen)
                                }
                            >
                                <img
                                    src={content.lang_select[langIndex].img}
                                    className="selected-flag"
                                />
                                <p className={lang}>
                                    {content.lang_select[langIndex].text}
                                </p>
                                <img src={arrowDown} />
                            </div>
                            {selectLangOpen && (
                                <div className={`langs-dropdown ${lang}`}>
                                    {content.lang_select.map((lang, index) => (
                                        <div
                                            className="lang"
                                            onClick={() => changeLang(index)}
                                            key={index}
                                        >
                                            <img src={lang.img} />
                                            <p>{lang.text}</p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <button
                            className={`spin-btn ${lang}`}
                            onClick={handleAccount(lang)}
                        >
                            {content.open_account}
                        </button>
                    </div>
                </div>
                {content.cars.map((val, index) => (
                    <div className={bannerClasses[index].img} key={index}>
                        <img src={val.img} className="full-img" />
                        <img src={val.img_mid} className="small-img" />
                    </div>
                ))}
                <div className="banner-bars">
                    {content.cars.map((val, index) => (
                        <div
                            onClick={() => setSelectBanner(index)}
                            key={index}
                            className="banner-bar"
                        >
                            <div className="bar-body">
                                <div className={bannerClasses[index].bar} />
                            </div>
                            <p>{val.title}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="banner-text">
                <p className="banner-title">{content.title}</p>
                {/* <p className="banner-subtitle">{content.subtitle}</p> */}
                <button
                    className="spin-btn"
                    onClick={() => scrollToAnchor("spin-wheel")}
                >
                    {content.spin_now}
                </button>
            </div>
        </div>
    );
};
